import { render } from "./ChatSettingsModal.vue?vue&type=template&id=60323fa0&scoped=true"
import script from "./ChatSettingsModal.vue?vue&type=script&lang=js"
export * from "./ChatSettingsModal.vue?vue&type=script&lang=js"

import "./ChatSettingsModal.vue?vue&type=style&index=0&id=60323fa0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60323fa0"]])

export default __exports__